// extracted by mini-css-extract-plugin
export default {"container":"Login_container__JohUm","forgotPasswordText":"Login_forgotPasswordText__uGp-+"};